import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import { logout, useAuthDispatch } from '../context';
import { useMountEffect } from '../hooks';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {toast} from 'react-toastify';

const Logout = () => {

	const dispatch = useAuthDispatch();
	const navigate = useNavigate();
	const { unAuthed } = useParams();

	const logoutAndBackToLoginPage = async () => {
		if (unAuthed) {
			toast.info('Your session has expired, please log in again');
		}
		
		try {
			// Set a timeout to ensure navigation happens even if logout is delayed
			const navigationTimeout = setTimeout(() => {
				console.log('Logout timeout reached, forcing navigation');
				navigate('/');
			}, 3000); // 3 seconds timeout
			
			await logout(dispatch, () => {
				clearTimeout(navigationTimeout);
			});
		} catch (error) {
			console.error('Logout error:', error);
			navigate('/');
		} finally {
			setTimeout(() => {
				navigate('/');
			}, 500);
		}
	}

	useMountEffect(logoutAndBackToLoginPage);

	return (
		<Container component="main" maxWidth="xs">
			<Typography variant="h5">Logging out...</Typography>
		</Container>
	);
}

export default Logout;